<template>
    <div class="muven-container">
        <div class="muven-router-name-container">
            <p class="muven-router-name">Lotes de produtos</p>
        </div>

        <div class="muven-content">
            <Breadcrumb :items="breadcrumbList" class="mb-3"/>

            <Loading page v-if="loading" />        

            <div class="muven-tip muven-tip-standalone tip-info mb-3" v-show="!loading">
                <fa icon="info" class="tip-icon" />
                <p>Lotes sem atualização a mais de 180 dias serão excluídos automaticamente.</p>
            </div>

            <ConfirmationExclusionModalCmp 
                ref="confirmationExclusionModal"
                @confirm="confirmBatchExclusionHandler" />

            <div class="modal" tabindex="-1" role="dialog" id="muven-product-batch-creation-batch-modal">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Criação de lote</h5>
                        </div>
                        <div class="modal-body">
                            <div class="form-group">
                                <label>Nome</label>
                                <input type="text" 
                                    class="form-control"
                                    v-model="newBatch.name">
                            </div>

                            <div class="form-group">
                                <label>Descrição</label>
                                <input type="text" 
                                    class="form-control"
                                    v-model="newBatch.description">
                            </div>

                            <div class="form-group">
                                <label>Tipo de lote</label>
                                <multiselect
                                    v-model="newBatch.batchTypeWrapper"
                                    :options="batchTypeOptions"
                                    :multiple="false"
                                    :show-labels="false"
                                    @select="batchTypeSelected"
                                    label="description"
                                    track-by="enum"
                                    placeholder="" />  
                            </div>

                            <div class="form-group" v-if="newBatch.isBatchTypePriceValueManagement()">
                                <label>Empresa base</label>
                                <multiselect
                                    v-model="newBatch.payload.storeWrapper"
                                    :options="storeList"
                                    :multiple="false"
                                    :show-labels="false"
                                    @select="selectStoreBatchTypePriceHandler"
                                    label="name"
                                    track-by="id"
                                    placeholder="" />  
                            </div>

                            <div class="form-group" v-if="newBatch.shouldShowChannel()">
                                <label>Canal</label>
                                <multiselect
                                    v-model="newBatch.payload.channelWrapper"
                                    :options="channelList"
                                    :multiple="false"
                                    :show-labels="false"
                                    @select="selectChannelBatchTypePriceHandler"
                                    label="name"
                                    track-by="id"
                                    placeholder="" />  
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button class="btn btn-primary"
                                :disabled="!newBatch.isValid() || newBatch.isLoading"
                                @click="createBatch(newBatch)">
                                Gravar

                                <Loading v-show="newBatch.isLoading" />
                            </button>

                            <button class="btn btn-outline-secondary"
                                :disabled="newBatch.isLoading"
                                @click="closeModalBatchCreation()">
                                Fechar
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal" tabindex="-1" role="dialog" id="muven-product-batch-modification-batch-modal">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Edição de lote</h5>    
                        </div>
                        <div class="modal-body">
                            <div class="form-group">
                                <label>Nome</label>
                                <input type="text" 
                                    class="form-control"
                                    v-model="chosenBatch.name">
                            </div>

                            <div class="form-group">
                                <label>Descrição</label>
                                <input type="text" 
                                    class="form-control"
                                    v-model="chosenBatch.description">
                            </div>

                            <div class="form-group" v-if="chosenBatch.isBatchTypePriceValueManagement()">
                                <label>Empresa base</label>
                                <multiselect
                                    v-model="chosenBatch.payload.storeWrapper"
                                    :options="storeList"
                                    :multiple="false"
                                    :show-labels="false"
                                    :disabled="true"
                                    label="name"
                                    track-by="id"
                                    placeholder="" />  
                            </div>

                            <div class="form-group" v-if="chosenBatch.isBatchTypePricePercentageManagement()">
                                <label>Canal</label>
                                <multiselect
                                    v-model="chosenBatch.payload.channelWrapper"
                                    :options="channelList"
                                    :multiple="false"
                                    :show-labels="false"
                                    :disabled="true"
                                    label="name"
                                    track-by="id"
                                    placeholder="" />  
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button class="btn btn-primary"
                                :disabled="!chosenBatch.isValid() || chosenBatch.isLoading"
                                @click="updateBatch(chosenBatch)">
                                Gravar

                                <Loading v-show="chosenBatch.isLoading" />
                            </button>

                            <button class="btn btn-outline-secondary"
                                :disabled="chosenBatch.isLoading"
                                @click="closeModalBatchModification()">
                                Fechar
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mb-3" v-if="!loading">
                <div>
                    <button type="button" 
                        class="btn btn-primary"
                        @click="showModalBatchCreation()">
                        Criar lote
                    </button>
                </div>
            </div>

            <NothingFound v-if="!loading && !hasBatchList" />

            <div v-if="!loading && hasBatchList">
                <div class="table-responsive">
                    <table class="table table-sm table-hover table-striped">
                        <thead>
                            <tr>
                                <th>Nome</th>
                                <th>Tipo</th>
                                <th>Criado em</th>
                                <th>Atualizado em</th>
                                <th></th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="(batch, index) in batchList" :key="index">
                                <td class="">{{batch.name}}</td>
                                <td class="">{{batch.getBatchTypeDescription() | infoOrPlaceholder}}</td>
                                <td class="">{{batch.createdAt | dateTimeFilter}}</td>
                                <td class="">{{batch.updatedAt | dateTimeFilter}}</td>
                                <td class="text-center muven-td-with-buttons">
                                    <button type="button" 
                                        class="btn btn-default text-muted" 
                                        data-toggle="dropdown" >
                                        <fa icon="ellipsis-v" v-show="!batch.isLoading" />
                                        <fa icon="sync-alt" spin v-show="batch.isLoading" />
                                    </button>

                                    <div class="dropdown-menu dropdown-menu-right muven-action-menu">
                                        <router-link class="dropdown-item"
                                            :to="batchDetails(batch)">
                                            <fa icon="box" fixed-width class="muven-action-icon" />
                                            <span class="muven-action-label">Produtos no lote</span>
                                        </router-link>

                                        <span class="dropdown-item"
                                            @click="showModalBatchModification(batch)">
                                            <fa icon="edit" fixed-width class="muven-action-icon" />
                                            <span class="muven-action-label">Editar</span>
                                        </span>

                                        <p class="dropdown-divider"></p>

                                        <span class="dropdown-item muven-action-danger"
                                            @click="openConfirmationBatchExclusionModal(batch)">
                                            <fa icon="trash-alt" fixed-width class="muven-action-icon" />
                                            <span class="muven-action-label">Excluir lote</span>
                                        </span>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <ListCount :amount="batchList.length" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import subscriberManager from '@/subscriber/managers/SubscriberManager'
import productBatchService from "@/product/services/ProductBatchService";
import channelService from "@/channel/services/ChannelService";
import { ProductBatchModel } from '../models/ProductBatchModel';
import ConfirmationExclusionModalCmp from '@/utils/components/ConfirmationExclusionModalCmp'
import { mapState } from 'vuex';
import { cloneDeep } from 'lodash';
import modalService from '@/utils/services/ModalService'
import { dateTimeFilter } from '@/utils/filters/DateTimeFilter'
import { infoOrPlaceholder } from "@/utils/filters/InformationOrPlaceholderFilter"
import { StoreModel } from '../../store/models/StoreModel';

const ID_MODIFICATION_BATCH_MODAL = "#muven-product-batch-modification-batch-modal";
const ID_CREATION_BATCH_MODAL = "#muven-product-batch-creation-batch-modal";

export default {
    name: 'ProductImageListView',
    components: {
        ConfirmationExclusionModalCmp,
    },
    filters: {
        dateTimeFilter,
        infoOrPlaceholder,
    },
    data() {
        return {
            loading: false,
            batchList: [],
            channelList: [],
            newBatch: new ProductBatchModel(),
            chosenBatch: new ProductBatchModel(),
            batchTypeOptions: ProductBatchModel.getBatchTypeOptions(subscriberManager.getPublicKeyFromStorage()),
            breadcrumbList: [
                {
                    id: 0,
                    description: 'Produtos',
                    path: '/produtos',
                },
                {
                    id: 1,
                    description: `Lotes de produtos`,
                    path: '',
                },
            ],
        }
    },
    async mounted() {
        this.loading = true;

        try {
            this.batchList = await productBatchService.getBatchList()
        } catch (e) {
            this.$floatingAlert.error({
                message: e.message,
            });
        }

        this.loading = false;
    },
    methods: {
        openConfirmationBatchExclusionModal(batch) {
            const info = {
                id: batch.id,
                title: 'Exclusão de lote',
                message: `Tem certeza que deseja excluir o lote <span style="font-weight: 600; color: var(--text-soft); text-transform: uppercase; letter-spacing: 1px;">${batch.name}</span>?`,
            }

            this.$refs.confirmationExclusionModal.open(info)
        },
        async confirmBatchExclusionHandler({id}) {
            try {
                await productBatchService.deleteBatch(id)
                this._removeBatchFromList(id)         
            } catch (err) {
                this.$floatingAlert.error({
                    message: err.message,
                })
            }

            this.$refs.confirmationExclusionModal.close()
        },
        async createBatch(batch) {
            batch.isLoading = true

            try {
                const newBatch = await productBatchService.createBatch(batch)
                this.batchList.push(newBatch)
                await this.closeModalBatchCreation()
            } catch (err) {
                this.$floatingAlert.error({
                    message: err.message,
                })
            }

            batch.isLoading = false
        },
        async updateBatch(batch) {
            batch.isLoading = true

            try {
                const updatedBatch = await productBatchService.createBatch(batch)

                for (let i = 0; i < this.batchList.length; i++) {
                    if (this.batchList[i].isEqual(updatedBatch)) {
                        this.batchList[i] = updatedBatch
                    }
                }

                await this.closeModalBatchModification()
            } catch (err) {
                this.$floatingAlert.error({
                    message: err.message,
                })
            }

            batch.isLoading = false
        },
        async showModalBatchCreation() {
            try {

                this.newBatch = new ProductBatchModel();
                this.newBatch.publicKey = subscriberManager.getPublicKeyFromStorage();

                if (!this.channelList.length) {
                    this.channelList = await channelService.getChannels()
                }

                await modalService.show(ID_CREATION_BATCH_MODAL)
            } catch (err) {
                this.$floatingAlert.error({
                    message: err.message,
                })
            }
        },
        async closeModalBatchCreation() {
            await modalService.hide(ID_CREATION_BATCH_MODAL)
        },
        async showModalBatchModification(batch) {
            this.chosenBatch = cloneDeep(batch)
            await modalService.show(ID_MODIFICATION_BATCH_MODAL)
        },
        async closeModalBatchModification() {
            await modalService.hide(ID_MODIFICATION_BATCH_MODAL)
        },
        batchTypeSelected(bt) {
            this.newBatch.updateBatchType(bt);
        },
        selectStoreBatchTypePriceHandler(store) {
            this.newBatch.updateStore(store)
        },
        selectChannelBatchTypePriceHandler(channel) {
            this.newBatch.updateChannel(channel)
        },
        _removeBatchFromList(id) {
            for (let i = 0; i < this.batchList.length; i++) {
                if (String(this.batchList[i].id) === String(id)) {
                    this.batchList.splice(i, 1)
                    break
                }
            }
        },
    },
    computed: {
        ...mapState({
            userAuthenticated: state => state.userAuthenticated,
            storeList: (state) => { 
                return StoreModel.getStoreListWithIdAndName(state.storeList)
            }
        }),
        hasBatchList() {
            return this.batchList.length > 0
        },
        batchDetails() {
            return (batch) => {
                if (batch.isBatchTypeStockManagement()) {
                    return `/produtos/lotes/${batch.id}/gerenciamento_estoque_por_loja_em_lote`
                }

                if (batch.isBatchTypePriceValueManagement()) {
                    return `/produtos/lotes/${batch.id}/gerenciamento_preco_fixo_por_canal_em_lote`
                }

                if (batch.isBatchTypePricePercentageManagement()) {
                    return `/produtos/lotes/${batch.id}/gerenciamento_preco_calculado_por_canal_em_lote`
                }

                if (batch.ifBatchTypeStockPercentageManagement()) {
                    return `/produtos/lotes/${batch.id}/gerenciamento_porcentagem_estoque_por_canal_em_lote`
                }

                return ''
            }
        }
    },  
}
</script>

<style lang="scss" scoped>

</style>